<template>
    <DModal
        :title="`${__('settings.accounting_products.products_modal.title')}: ${props.accountingProduct?.id ?? null} - ${props.accountingProduct?.name ?? null}`"
        is-big
        :show="showModal"
        @close="closeModal"
    >
        <DCard padding>
            <DTable
                :fields="fields"
                :items="props.accountingProduct.products"
            >
                <template #id="{item}">
                    <td v-if="userPermissions.includes('product.view')">
                        <Link
                            :href="routeLink(item)"
                        >
                            {{ item.id }}
                        </Link>
                    </td>
                    <td v-else>
                        {{ item.id }}
                    </td>
                </template>
            </DTable>
        </DCard>
    </DModal>
</template>

<script setup>
import { __ } from '~@/Composables/translation'
import { route } from '~@/Composables/route'
import { computed } from 'vue'
import { usePage } from '@inertiajs/vue3'

const props = defineProps({
    showModal: {
        type: Boolean,
        default: false
    },
    accountingProduct: {
        type: Object,
        default: () => {
            return {}
        }
    }

})

const fields = [
    { key: 'id', label: __('settings.accounting_products.products_modal.id') },
    { key: 'name', label: __('settings.accounting_products.products_modal.name') }
]

const userPermissions = computed(() => usePage().props.auth.permissions)

const emit = defineEmits(['close-modal'])

const closeModal = () => {
    emit('close-modal')
}

function routeLink (item) {
    if (item.is_addon === true) {
        return route('products.product-addons.show', { product: item.id })
    }

    return route('products.products.show', { product: item.id })
}

</script>

<style lang="scss">
</style>
